<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改入库单' : '新增入库单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="115px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="入库类型" prop="commodityInputOrderTypeEnum">
          <EnumSelect
            enumName="CommodityInputOrderTypeEnum"
            :multiple="false"
            placeholder="请选择入库类型"
            v-model="headInfo.commodityInputOrderTypeEnum"
            @change="changeTypeEnum"
          >
          </EnumSelect>
        </el-form-item>

        <div v-if="headInfo.commodityInputOrderTypeEnum == 'SaleReturnOrder'">
          <el-form-item label="客户" prop="customerSupplierId">
            <CustomerSelect
              :value="customer"
              @select="selectCustomer"
            ></CustomerSelect>
          </el-form-item>
          <el-row :gutter="10" v-if="headInfo.customerSupplierId">
            <el-col :span="6">
              <el-form-item label="联系人信息" prop="customerSupplierId">
                <el-input
                  v-model="headInfo.customerSupplierName"
                  placeholder="请输入联系人姓名"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierPhoneNumber"
                  placeholder="请输入联系方式"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierAddress"
                  placeholder="请输入联系地址"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div v-else>
          <el-form-item label="供应商" prop="customerSupplierId">
            <SupplierSelect
              :value="supplier"
              @select="selectSupplier"
            ></SupplierSelect>
          </el-form-item>
        </div>

        <el-form-item label="关联单据" prop="relatedOrderHeadId">
          <el-input
            :value="getSelectLabel('RelatedOrder')"
            :placeholder="
              getSelectLabel('RelatedOrder') || '请选择需要入库的单据'
            "
            style="width: 400px"
            readonly
            suffix-icon="el-icon-arrow-right"
            @click.native="toSelectOrderPage"
          ></el-input>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalInputQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="totalInputQuantity && totalInputQuantity > 0"
            >
              {{ "共 " + totalInputQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectOrderItemPage('exist')"
              >选择商品</el-button
            >
          </div>
        </el-form-item>

        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.relatedOrderItemId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="getCommodityOrderItem(scope.row).commoditySnapshot"
                :commoditySpec="
                  getCommodityOrderItem(scope.row).commoditySpecSnapshot
                "
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySnapshot.name"
            label="商品信息"
            min-width="150"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <span style="font-size: 1.1em">{{
                  getCommodityOrderItem(scope.row).commoditySnapshot.name
                }}</span
                ><br />
                {{
                  "规格：" +
                  getCommodityOrderItem(scope.row).commoditySpecSnapshot
                    .specName
                }}<br />
                {{
                  "分类：" +
                  getCommodityOrderItem(scope.row).commoditySnapshot
                    .commodityCategory.name
                }}<br />
                {{
                  "颜色：" +
                  getCommodityOrderItem(scope.row).commoditySnapshot.color
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="入库数量"
            width="430"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-table
                :data="scope.row.orderWareHouseAddNewPojoList || []"
                stripe
                border
                style="width: 100%"
                :row-key="
                  (row) => {
                    return scope.row.itemNo + row.itemNo + row.wareHouseId;
                  }
                "
              >
                <el-table-column
                  prop="name"
                  label="仓库"
                  min-width="200"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    {{
                      innerScope.row.wareHouse
                        ? innerScope.row.wareHouse.name
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="数量"
                  min-width="200"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    <CommodityQuantityInputBox
                      :key="
                        'orderWareHouseItemQuantityInputNumber' +
                        innerScope.$index +
                        itemQuantityKey
                      "
                      v-model="innerScope.row.itemQuantity"
                      size="small"
                      :max="getRelatedOrderItem(scope.row).toBeInputQuantity"
                      @change="
                        (e) => {
                          changeOrderWareHouseItemQuantity(
                            scope.$index,
                            innerScope.$index,
                            innerScope.row,
                            e
                          );
                        }
                      "
                    ></CommodityQuantityInputBox>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="合计数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.itemQuantity }}
            </template>
          </el-table-column>
          <el-table-column
            label="入库详情"
            width="200"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div
                v-for="(item, index) in scope.row.orderWareHouseAddNewPojoList"
                :key="index"
              >
                <div>
                  {{
                    "仓库：" +
                    item.wareHouse.name +
                    "，数量：" +
                    item.itemQuantity +
                    " " +
                    getCommodityOrderItem(scope.row).commoditySnapshot.unit
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <template
          v-if="headInfo.commodityInputOrderTypeEnum == 'SaleReturnOrder'"
        >
          <el-form-item label="" prop="needDelivery" class="fm-mt-10">
            <span slot="label">
              <el-tooltip effect="dark" content="" placement="top-start">
                <div slot="content" style="line-height: 1.5em">
                  <div style="font-weight: bold">配送标识说明</div>
                  配送标识所选商品是否需要配送，选项会影响后续单据流程。<br />
                  若需要配送则需要选择配送员将商品配送入库，配送原则为‘谁送出谁拉回’；<br />
                  无需配送则代表无需配送员配送商品
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              配送标识
            </span>
            <div class="fm-flex">
              <el-switch
                v-model="headInfo.needDelivery"
                :active-color="$jsTool.getColor('success')"
                :inactive-color="$jsTool.getColor('warning')"
                @change="handleNeedDelivery"
              >
              </el-switch>
              <p
                v-fmtype="'success'"
                class="fm-ml-10"
                v-if="headInfo.needDelivery"
              >
                需要配送
              </p>
              <span v-fmtype="'warning'" class="fm-ml-10" v-else>无需配送</span>
            </div>
          </el-form-item>

          <template v-if="headInfo.needDelivery">
            <el-form-item label="配送员" prop="deliveryUserIdList">
              <DeliveryUserTransfer
                v-model="headInfo.deliveryUserIdList"
                :saleReturnOrderId="relatedSaleReturnOrderHead.id"
                :userList="deliveryUserList"
                @addUser="addDeliveryUser"
                @cancelUser="cancelDeliveryUser"
              ></DeliveryUserTransfer>
            </el-form-item>
          </template>
        </template>

        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="
              $envConfig.VUE_APP_uploadCommodityInputOrderPaperOrder + ''
            "
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="50"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入单据备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <SaleReturnOrderSelectDialog
      :show="saleReturnOrderSelectDialogShow"
      :customerId="customer.id"
      from="CommodityInputOrder"
      :selectList="itemList"
      @close="saleReturnOrderSelectDialogShow = false"
      @selectSaleReturnOrder="selectSaleReturnOrder"
      v-if="saleReturnOrderSelectDialogShow"
    >
    </SaleReturnOrderSelectDialog>

    <SaleReturnOrderItemSelectDialog
      :show="saleReturnOrderItemSelectDialogShow"
      from="CommodityInputOrder"
      :customerId="customer.id"
      :saleReturnOrderId="relatedSaleReturnOrderHead.id"
      :selectList="itemList"
      @close="saleReturnOrderItemSelectDialogShow = false"
      @selectSaleReturnOrderItem="selectSaleReturnOrderItem"
      v-if="saleReturnOrderItemSelectDialogShow"
    >
    </SaleReturnOrderItemSelectDialog>

    <PurchaseOrderSelectDialog
      :show="purchaseOrderSelectDialogShow"
      :supplierId="supplier.id"
      from="CommodityInputOrder"
      :selectList="itemList"
      @close="purchaseOrderSelectDialogShow = false"
      @selectPurchaseOrder="selectPurchaseOrder"
      v-if="purchaseOrderSelectDialogShow"
    >
    </PurchaseOrderSelectDialog>

    <PurchaseOrderItemSelectDialog
      :show="purchaseOrderItemSelectDialogShow"
      from="CommodityInputOrder"
      :supplierId="supplier.id"
      :purchaseOrderId="relatedPurchaseOrderHead.id"
      :selectList="itemList"
      @close="purchaseOrderItemSelectDialogShow = false"
      @selectPurchaseOrderItem="selectPurchaseOrderItem"
      v-if="purchaseOrderItemSelectDialogShow"
    >
    </PurchaseOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityInputOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          Object.assign(this.$data, this.$options.data());
          this.$nextTick(() => {
            this.$refs.editOrderFormRef.clearValidate();
          });
          this.initOrderData();
          this.getOrderConfig();
          this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
          this.getCanSelectWareHouseList();
          setTimeout(async () => {
            if (this.orderId) {
              await this.getOrderInfo();
            }
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    totalInputQuantity() {
      return Number(
        this.$jsTool.sumQuantity(this.itemList.map((d) => d.itemQuantity))
      );
    },
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        commodityInputOrderTypeEnum: this.$ruleUtil.simple({
          fieldName: "入库类型",
          handleType: "选择",
          required: true,
        }),
        customerSupplierId: this.$ruleUtil.simple({
          fieldName: "客户/供应商",
          handleType: "选择",
          required: true,
        }),
        relatedOrderHeadId: this.$ruleUtil.simple({
          fieldName: "关联单据",
          handleType: "选择",
          required: true,
        }),
        totalInputQuantity: this.$ruleUtil.quantity(
          "入库商品",
          this.quantityMinLimit
        ),
        paperOrderSysFileIdList: this.$ruleUtil.array(
          "纸质单据",
          "上传",
          this.orderConfig.paperOrderRequired ? 1 : 0,
          10
        ),
        remark: this.$ruleUtil.simple({
          fieldName: "备注",
          required: false,
          max: 200,
        }),
      };
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        res.customerSupplierName = this.$ruleUtil.simple({
          fieldName: "联系人姓名",
          required: true,
          max: 50,
        });
        res.customerSupplierPhoneNumber = this.$ruleUtil.simple({
          fieldName: "联系方式",
          required: true,
          max: 20,
        });
        res.customerSupplierAddress = this.$ruleUtil.simple({
          fieldName: "联系地址",
          required: true,
          max: 20,
        });
        if (this.headInfo.needDelivery) {
          res.deliveryUserIdList = this.$ruleUtil.array("配送员", "选择", 1);
        }
      }
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        paperOrderRequired: true,
      },

      // 预选的单据信息
      preInfo: {
        saleReturnOrderId: null,
        saleReturnOrder: {},
        purchaseOrderId: null,
        purchaseOrder: {},
      },

      orderDatePickerShow: false,
      commodityInputOrderTypeEnumPickerShow: false,

      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        commodityInputOrderTypeEnum: "",
        orderDate: null,
        customerSupplierId: null,
        customerSupplierName: null,
        customerSupplierPhoneNumber: null,
        customerSupplierAddress: "",
        relatedOrderHeadId: null,
        totalInputQuantity: 0,
        needDelivery: true,
        deliveryUserIdList: [],
        paperOrderSysFileIdList: [],
        remark: "",
        orderParam: "",
      },
      itemList: [],
      customer: {},
      supplier: {},
      relatedSaleReturnOrderHead: {},
      relatedPurchaseOrderHead: {},
      deliveryUserList: [],
      paperOrderImageList: [],

      selectWareHousePopupShow: false,
      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      saleReturnOrderSelectDialogShow: false,
      purchaseOrderSelectDialogShow: false,
      saleReturnOrderItemSelectDialogShow: false,
      purchaseOrderItemSelectDialogShow: false,

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },
  methods: {
    getRelatedOrderItem(item) {
      return this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder"
        ? item.relatedSaleReturnOrderItem
        : item.relatedPurchaseOrderItem;
    },
    getCommodityOrderItem(item) {
      return this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder"
        ? item.relatedSaleReturnOrderItem.relatedSaleOrderItem
        : item.relatedPurchaseOrderItem;
    },
    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 业务员
    addDeliveryUser(list) {
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message.error("请先选择客户");
          return;
        }
        if (
          !this.relatedSaleReturnOrderHead ||
          !this.relatedSaleReturnOrderHead.id
        ) {
          this.$message.error("请先选择销售退货单");
          return;
        }
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message.error("请先选择供应商");
          return;
        }
        if (
          !this.relatedPurchaseOrderHead ||
          !this.relatedPurchaseOrderHead.id
        ) {
          this.$message.error("请先选择采购单");
          return;
        }
      }
      this.deliveryUserList = this.deliveryUserList.concat(list);
    },
    cancelDeliveryUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.deliveryUserList = this.deliveryUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },
    async getCanSelectWareHouseList(args) {
      let res = await this.$api.wareHouse_findListForSelect(args);
      if (res && res.success) {
        this.canSelectWareHouseList = res.data;
      }
    },
    canSelectWareHouseListBySpec(commoditySpec) {
      let res = commoditySpec.commoditySpecWareHouseList.map((d) => {
        return {
          label: d.wareHouse.name,
          wareHouse: d.wareHouse,
          wareHouseId: d.wareHouseId,
          fictitiousQuantity: d.fictitiousQuantity,
          availableQuantity: d.availableQuantity,
          desc: "虚拟库存 " + d.fictitiousQuantity,
        };
      });
      let oldIdList = res.map((d) => d.wareHouseId);
      if (
        this.canSelectWareHouseList &&
        this.canSelectWareHouseList.length > 0
      ) {
        res = res.concat(
          this.canSelectWareHouseList
            .filter((d) => oldIdList.indexOf(d.id) < 0)
            .map((d) => {
              return {
                label: d.name,
                wareHouse: d,
                wareHouseId: d.id,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                desc: "该仓库中没有此规格",
              };
            })
        );
      }
      return res;
    },
    // 报损单选择仓库
    showSelectWareHousePopup(index) {
      this.wareHouseList = this.canSelectWareHouseListBySpec(
        this.getCommodityOrderItem(this.editItem).commoditySpec
      );
      this.selectWareHousePopupIndex = index;
      this.selectWareHousePopupShow = true;
    },
    selectWareHousePopupConfirm(e) {
      if (e && e.value && e.value[0]) {
        let data = e.value[0];
        if (
          this.editItem.orderWareHouseAddNewPojoList.findIndex(
            (d) => d.wareHouseId && d.wareHouseId == data.wareHouseId
          ) > -1
        ) {
          this.$message.error("请勿重复选择仓库");
          this.selectWareHousePopupShow = false;
          return;
        }
        this.editItem.orderWareHouseAddNewPojoList.splice(
          this.selectWareHousePopupIndex,
          1,
          {
            ...this.editItem.orderWareHouseAddNewPojoList[
              this.selectWareHousePopupIndex
            ],
            wareHouse: data.wareHouse,
            wareHouseId: data.wareHouseId,
            fictitiousQuantity: data.fictitiousQuantity,
            availableQuantity: data.availableQuantity,
          }
        );
        this.selectWareHousePopupShow = false;
      }
    },
    specWareHouseNowQuantityChange() {
      this.editItem.itemQuantity = Number(
        this.$jsTool.sumQuantity(
          this.editItem.orderWareHouseAddNewPojoList.map(
            (d) => d.itemQuantity || 0
          )
        )
      );
    },
    addSpecWareHouseItem(index) {
      this.editItem.orderWareHouseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.editItem.orderWareHouseAddNewPojoList[
            this.editItem.orderWareHouseAddNewPojoList.length - 1
          ].itemNo + 1,
        itemQuantity: 1,
      });
      this.specWareHouseNowQuantityChange();
    },
    deleteSpecWareHouseItem(index) {
      let that = this;
      this.$confirm("确认删除所选仓库信息？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          that.editItem.orderWareHouseAddNewPojoList.splice(index, 1);
          that.specWareHouseNowQuantityChange();
        })
        .catch(() => {});
    },
    initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.commodityInputOrderTypeEnum = "SaleReturnOrder";
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CommodityInputOrder:NeedApproval",
        "Order:CommodityInputOrder:EditCustomer",
        "Order:CommodityInputOrder:PaperOrderRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityInputOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityInputOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityInputOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
      }
    },
    changeOrderWareHouseItemQuantity(
      index,
      subIndex,
      row,
      orderWareHouseValue
    ) {
      if (orderWareHouseValue < 0) {
        row.itemQuantity = 0;
      }
      if (orderWareHouseValue <= 0) {
        if (this.itemList[index].orderWareHouseAddNewPojoList.length != 1) {
          this.itemList[index].orderWareHouseAddNewPojoList.splice(subIndex, 1);
        }
      } else {
        this.itemList[index].orderWareHouseAddNewPojoList.splice(
          subIndex,
          1,
          row
        );
      }
      let itemQuantity = this.itemList[
        index
      ].orderWareHouseAddNewPojoList.reduce((sum, current) => {
        return sum + current.itemQuantity;
      }, 0);
      this.changeItemQuantity(index, this.itemList[index], itemQuantity);
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value < 0) {
        row.itemQuantity = 0;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList[index].orderWareHouseAddNewPojoList.splice(0, 1);
            that.itemList.splice(index, 1);
            this.itemQuantityKey = Math.random();
            if (
              that.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder"
            ) {
              that.selectSaleReturnOrderItem(that.itemList || []);
            } else {
              that.selectPurchaseOrderItem(that.itemList || []);
            }
          })
          .catch(() => {
            this.itemList[index].orderWareHouseAddNewPojoList[0].itemQuantity =
              that.quantityMinLimit;
            row.itemQuantity = that.quantityMinLimit;
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        row = {
          ...row,
          itemQuantity: value,
        };
        that.itemList.splice(index, 1, row);
        if (that.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
          that.selectSaleReturnOrderItem(that.itemList || []);
        } else {
          that.selectPurchaseOrderItem(that.itemList || []);
        }
      }
    },
    changeItemAmount(index, row) {
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.itemList.splice(index, 1, row);
        this.selectSaleReturnOrderItem(this.itemList || []);
      }
    },
    handleNeedDelivery(e) {
      this.headInfo.needDelivery = e;
    },
    // 获取已选择的文本
    getSelectLabel(type) {
      if (type == "DeliveryUser") {
        if (this.deliveryUserList && this.deliveryUserList.length > 0) {
          return this.deliveryUserList
            .map((item) => {
              return item.name;
            })
            .join("、");
        }
      } else if (type == "Customer") {
        if (this.customer && this.customer.name) {
          return this.customer.customerNo + " " + this.customer.name;
        }
      } else if (type == "Supplier") {
        if (this.supplier && this.supplier.name) {
          return this.supplier.name;
        }
      } else if (type == "RelatedOrder") {
        if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
          if (
            this.relatedSaleReturnOrderHead &&
            this.relatedSaleReturnOrderHead.id
          ) {
            return this.relatedSaleReturnOrderHead.orderNo;
          }
        } else {
          if (
            this.relatedPurchaseOrderHead &&
            this.relatedPurchaseOrderHead.id
          ) {
            return this.relatedPurchaseOrderHead.orderNo;
          }
        }
      }
      return null;
    },
    // 选择入库类型
    changeTypeEnum() {
      // this.headInfo.commodityInputOrderTypeEnum = e.value[0].Name;
      this.headInfo.customerSupplierId = null;
      this.headInfo.customerSupplierName = null;
      this.headInfo.customerSupplierPhoneNumber = null;
      this.headInfo.customerSupplierAddress = "";
      this.headInfo.relatedOrderHeadId = null;
      this.headInfo.needDelivery =
        this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder";
      this.itemList = [];
      this.customer = {};
      this.supplier = {};
      this.relatedSaleReturnOrderHead = {};
      this.relatedPurchaseOrderHead = {};
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.selectSaleReturnOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField(
          "commodityInputOrderTypeEnum"
        );
      });
    },
    selectCustomer(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = item.name;
      this.headInfo.customerSupplierPhoneNumber = item.phoneNumber;
      this.headInfo.customerSupplierAddress = item.address;
      this.customer = item;
      // 清空已选销售单和商品
      this.itemList = [];
      this.headInfo.relatedOrderHeadId = null;
      this.relatedSaleReturnOrderHead = {};
      this.relatedPurchaseOrderHead = {};
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.selectSaleReturnOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseOrderItem(this.itemList || []);
      }
      this.$message.success("已自动更新联系人信息");
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrderPage();
      }, 200);
    },
    selectSupplier(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = "";
      this.headInfo.customerSupplierPhoneNumber = "";
      this.headInfo.customerSupplierAddress = "";
      this.supplier = item;
      // 清空已选销售单和商品
      this.headInfo.relatedOrderHeadId = null;
      this.relatedSaleReturnOrderHead = {};
      this.relatedPurchaseOrderHead = {};
      this.itemList = [];
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.selectSaleReturnOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrderPage();
      }, 200);
    },
    // 选择销售单
    toSelectOrderPage() {
      if (this.preInfo.saleReturnOrderId || this.preInfo.purchaseOrderId) {
        this.$message.error("自动创建入库单时无法重新选择入库单据");
        return;
      }
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message.error("请先选择客户");
          return;
        }
        this.saleReturnOrderSelectDialogShow = true;
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message.error("请先选择供应商");
          return;
        }
        this.purchaseOrderSelectDialogShow = true;
      }
    },
    selectSaleReturnOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedSaleReturnOrderHead = order;
      this.itemList = [];
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.selectSaleReturnOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectOrderItemPage();
      }, 200);
    },
    selectPurchaseOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedPurchaseOrderHead = order;
      this.itemList = [];
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        this.selectSaleReturnOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectOrderItemPage();
      }, 200);
    },

    // 选择单据行项目
    async toSelectOrderItemPage(exist) {
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message.error("请先选择客户");
          return;
        }
        if (
          !this.relatedSaleReturnOrderHead ||
          !this.relatedSaleReturnOrderHead.id
        ) {
          this.$message.error("请先选择销售退货单");
          return;
        }
        this.saleReturnOrderSelectDialogShow = false;
        if (!exist) {
          let getOrderRes = await this.$api.saleReturnOrder_findVoById(
            this.headInfo.relatedOrderHeadId,
            {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "加载中...",
              },
            }
          );
          if (getOrderRes && getOrderRes.success) {
            let saleReturnOrderVo = getOrderRes.data;
            this.handleConstructItemInfo(saleReturnOrderVo.itemList);
            return;
          }
        }
        this.saleReturnOrderItemSelectDialogShow = true;
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message.error("请先选择供应商");
          return;
        }
        if (
          !this.relatedPurchaseOrderHead ||
          !this.relatedPurchaseOrderHead.id
        ) {
          this.$message.error("请先选择采购单");
          return;
        }
        this.purchaseOrderSelectDialogShow = false;
        if (!exist) {
          let getOrderRes = await this.$api.purchaseOrder_findVoById(
            this.headInfo.relatedOrderHeadId,
            {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "加载中...",
              },
            }
          );
          if (getOrderRes && getOrderRes.success) {
            let purchaseOrderVo = getOrderRes.data;
            this.handleConstructItemInfo(purchaseOrderVo.itemList);
            return;
          }
        }
        this.purchaseOrderItemSelectDialogShow = true;
      }
    },
    async handleConstructItemInfo(itemList) {
      if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
        let commodityIdList = itemList.map(
          (d) => d.relatedSaleOrderItem.commodityId
        );
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }
        let res = [];
        for (let index in itemList) {
          let item = itemList[index];
          if (item.toBeInputQuantity <= 0) {
            continue;
          }
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == item.relatedSaleOrderItem.commodityId
          )[0];
          item.relatedSaleOrderItem = {
            ...item.relatedSaleOrderItem,
            commodity: commodityVo.commodity,
            commoditySpec: commodityVo.commoditySpecList.filter(
              (f) => f.id == item.relatedSaleOrderItem.commoditySpecId
            )[0],
          };
          let constructItem = {
            itemNo: index + 1,
            relatedOrderItemId: item.id,
            relatedSaleReturnOrderItem: item,
            relatedSaleReturnOrderItemId: item.id,
            itemQuantity: item.toBeInputQuantity,
            orderWareHouseAddNewPojoList: [
              {
                itemNo: 1,
                wareHouse: null,
                wareHouseId: null,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                itemQuantity: item.toBeInputQuantity,
              },
            ],
          };
          let specWareHouse =
            item.relatedSaleOrderItem.commoditySpec
              .commoditySpecWareHouseList[0];
          constructItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: item.toBeInputQuantity,
            },
          ];
          res.push(constructItem);
        }
        this.selectSaleReturnOrderItem(res);
      } else {
        let commodityIdList = itemList.map((d) => d.commodityId);
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }
        let res = [];
        for (let index in itemList) {
          let item = itemList[index];
          if (item.toBeInputQuantity <= 0) {
            continue;
          }
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == item.commodityId
          )[0];
          item.commodity = commodityVo.commodity;
          item.commoditySpec = commodityVo.commoditySpecList.filter(
            (f) => f.id == item.commoditySpecId
          )[0];
          let constructItem = {
            itemNo: index + 1,
            relatedOrderItemId: item.id,
            relatedPurchaseOrderItem: item,
            relatedPurchaseOrderItemId: item.id,
            itemQuantity: item.toBeInputQuantity,
            commodityRetailTotalAmount: this.$jsTool.multi(item.retailPrice, 1),
            orderWareHouseAddNewPojoList: [
              {
                itemNo: 1,
                wareHouse: null,
                wareHouseId: null,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                itemQuantity: item.toBeInputQuantity,
              },
            ],
          };
          let specWareHouse = item.commoditySpec.commoditySpecWareHouseList[0];
          constructItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: item.toBeInputQuantity,
            },
          ];
          res.push(constructItem);
        }
        this.selectPurchaseOrderItem(res);
      }
    },
    selectSaleReturnOrderItem(itemList) {
      this.itemList = itemList;
      this.headInfo.totalInputQuantity = Number(
        this.$jsTool.sumQuantity(itemList.map((d) => d.itemQuantity))
      );
      this.$refs.editOrderFormRef.validateField("totalInputQuantity");
    },
    selectPurchaseOrderItem(itemList) {
      this.itemList = itemList;
      this.headInfo.totalInputQuantity = Number(
        this.$jsTool.sumQuantity(itemList.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalInputQuantity");
      });
    },
    async getOrderInfo(args) {
      let res = await this.$api.commodityInputOrder_findVoById(
        this.orderId,
        args
      );
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          commodityInputOrderTypeEnum:
            res.data.head.commodityInputOrderTypeEnum.Name,
          deliveryUserIdList: res.data.head.deliveryUserList.map(
            (d) => d.userId
          ),
          remark: res.data.head.remark || "",
          paperOrderSysFileIdList: res.data.head.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
        };
        // 获取商品信息
        let commodityIdList = res.data.itemList.map(
          (d) => this.getCommodityOrderItem(d).commodityId
        );
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }

        this.itemList = res.data.itemList.map((d) => {
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == this.getCommodityOrderItem(d).commodityId
          )[0];
          let item = d;
          if (this.headInfo.commodityInputOrderTypeEnum == "SaleReturnOrder") {
            item.relatedSaleReturnOrderItem.relatedSaleOrderItem = {
              ...item.relatedSaleReturnOrderItem.relatedSaleOrderItem,
              commodity: commodityVo.commodity,
              commoditySpec: commodityVo.commoditySpecList.filter(
                (f) =>
                  f.id ==
                  item.relatedSaleReturnOrderItem.relatedSaleOrderItem
                    .commoditySpecId
              )[0],
            };
          } else {
            item.relatedPurchaseOrderItem = {
              ...item.relatedPurchaseOrderItem,
              commodity: commodityVo.commodity,
              commoditySpec: commodityVo.commoditySpecList.filter(
                (f) => f.id == item.relatedPurchaseOrderItem.commoditySpecId
              )[0],
            };
          }

          item.orderWareHouseAddNewPojoList = d.orderWareHouseList.map((f) => {
            let canSelectWareHouseListBySpec =
              this.canSelectWareHouseListBySpec(
                this.getCommodityOrderItem(item).commoditySpec
              );
            let specWareHouse =
              canSelectWareHouseListBySpec.length == 1
                ? canSelectWareHouseListBySpec[0]
                : {};
            return {
              itemNo: f.itemNo,
              wareHouse: f.wareHouse,
              wareHouseId: f.wareHouseId,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.fictitiousQuantity || 0,
              itemQuantity: f.itemQuantity,
            };
          });
          return item;
        });
        this.customer = res.data.head.customer;
        this.supplier = res.data.head.supplier;
        this.relatedSaleReturnOrderHead =
          res.data.head.relatedSaleReturnOrderHead;
        this.relatedPurchaseOrderHead = res.data.head.relatedPurchaseOrderHead;
        this.deliveryUserList = res.data.head.deliveryUserList.map(
          (d) => d.user
        );
        this.paperOrderImageList = res.data.head.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.saleReturnOrderId = orderParam.preInfo.saleReturnOrderId;
          this.preInfo.purchaseOrderId = orderParam.preInfo.purchaseOrderId;
        }
      }
    },
    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.commodityInputOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.commodityInputOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.commodityInputOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.commodityInputOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CommodityInputOrderEditDialog.vue